import { render, staticRenderFns } from "./Loginform.vue?vue&type=template&id=1cab5e2a&"
import script from "./Loginform.vue?vue&type=script&lang=js&"
export * from "./Loginform.vue?vue&type=script&lang=js&"
import style0 from "./Loginform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports